import { render, staticRenderFns } from "./tahunajaran.vue?vue&type=template&id=7839e21c&"
import script from "./tahunajaran.vue?vue&type=script&lang=js&"
export * from "./tahunajaran.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports